module.exports = __webpack_public_path__ + "img/教育.4b1167a5.gif";